import React from "react";
import * as RechartsPrimitive from "recharts";
import { ChartTooltipContent } from "../../ui/chart";

interface CategoryColorTooltipContentProps extends React.ComponentProps<
  typeof RechartsPrimitive.Tooltip
> {
  getCategoryColor: (key: string, muted?: boolean) => string;
  comparisonYear: number | string;
}

export function CategoryColorTooltipContent({
  getCategoryColor,
  comparisonYear,
  payload,
  content: _content,
  ...props
}: CategoryColorTooltipContentProps) {
  const coloredPayload = React.useMemo(() => {
    if (!payload?.length) return payload;
    const categoryKey = payload[0]?.payload?.key;
    if (!categoryKey) return payload;

    return payload.map((item) => ({
      ...item,
      color: getCategoryColor(categoryKey, String(item.dataKey) === String(comparisonYear)),
    }));
  }, [payload, getCategoryColor, comparisonYear]);

  return <ChartTooltipContent {...props} payload={coloredPayload} indicator="dot" />;
}
